<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-8">

      <h1 class="display-6 fw-bold mb-2">About</h1>
      <hr>

      <section class="mb-5">
        <p class="lead">Vocabulary is an open-source vocabulary learning application that brings the simplicity of a paper vocabulary notebook into a modern digital format — with flashcards, spaced repetition, and multi-language support.</p>
      </section>

      <section class="mb-5">
        <h2 class="h5 fw-semibold mb-3">Architecture</h2>
        <div class="row g-3">
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title fw-semibold">Frontend</h6>
                <p class="card-text small text-body-secondary">Angular 20 with Angular Material and Bootstrap. Single-page application served via Nginx.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title fw-semibold">Backend</h6>
                <p class="card-text small text-body-secondary">REST API built with <a href="https://spring.io/projects/spring-boot" target="_blank" rel="noopener">Spring Boot</a>, using <a href="https://www.jooq.org" target="_blank" rel="noopener">jOOQ</a> for type-safe SQL and <a href="https://www.postgresql.org" target="_blank" rel="noopener">PostgreSQL</a> as the database. Automatic word translation powered by <a href="https://azure.microsoft.com/en-us/products/ai-services/ai-translator" target="_blank" rel="noopener">Azure AI Translator</a>.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title fw-semibold">Authentication</h6>
                <p class="card-text small text-body-secondary">Identity and access management via <a href="https://www.keycloak.org" target="_blank" rel="noopener">Keycloak</a>, supporting standard login and Google OAuth.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title fw-semibold">Infrastructure</h6>
                <p class="card-text small text-body-secondary">Hosted on <a href="https://www.hetzner.com" target="_blank" rel="noopener">Hetzner Cloud</a> with Nginx as reverse proxy and TLS termination. The REST API, database, and Keycloak run as Docker containers.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mb-5">
        <h2 class="h5 fw-semibold mb-3">People</h2>
        <div class="row g-3">
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title fw-semibold">Enrico Giurin</h6>
                <p class="card-text small text-body-secondary mb-2">Software Engineer based in Zurich. Creator and maintainer of Vocabulary.</p>
                <a href="https://github.com/egch" target="_blank" rel="noopener" class="small">github.com/egch</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 class="h5 fw-semibold mb-3">Built On</h2>
        <p class="small text-body-secondary">
          Vocabulary is built on top of <a href="https://github.com/your-rents" target="_blank" rel="noopener">your-rents</a>,
          an open-source project created by <a href="https://github.com/benfante" target="_blank" rel="noopener">Lucio Benfante</a>.
          We are grateful for the solid foundation it provided.
        </p>
      </section>

    </div>
  </div>
</div>
